import React, { useMemo, useEffect, useContext } from 'react';
import { Grid } from '@mui/material';
import { useSearchParams, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import IncubatorCycleTable from '../../AppGrid/IncubatorCycleTable';
import strings from '../../Globalization/index';
import { useBreadcrumbs } from '../../contexts/Breadcrumbs';
import consts from '../../consts';

const DashboardIncubatorList = () => {
	const [searchParams] = useSearchParams();
	const [breadcrumbs, setBreadcrumbs] = useBreadcrumbs();
	const navigate = useNavigate();
	useEffect(() => {
		setBreadcrumbs({
			breadcrumbs: [{ text: strings.IncubatorCycleList || 'Cycles' }],
			docTitle: strings.IncubatorCycleList,
			subbreadcrumbs: [{ text: strings.Dashboard, to: '/dashboard' }, { text: strings.IncubatorCycleList || 'Incubator Cycle' }]
		});
	}, [])
	const params = { disableLoadPref: true, hideTypeFilter: true };
	const equipmentTypeId = searchParams.get('equipmentTypeId');
	const BIResult = searchParams.get('BIResult');
	const IsSterilized = Boolean(searchParams.get('IsSterilized'));
	const locationId = searchParams.get('locationId');
	const parentFilters = useMemo(() => {
		const date = dayjs().hour(0).minute(0).second(0);
		const utcDate = date.utc().millisecond(0).toISOString();
		let filters = [
			{ "operator": "$eq", "value": BIResult, "property": "Result", "type": "numeric" },
			{ "operator": "$gt", "value": utcDate, "property": "CycleStart", "type": "date", "convert": "true", "utcDate": utcDate },
			{ "operator": "$eq", "value": consts.SterilizeStatus.True, "property": "IsSterilized", "type": "boolean" }
		];
		return { filter: filters };
	}, [BIResult, equipmentTypeId, IsSterilized]);


	return (
		<Grid container>
			<Grid size={12}>
				<IncubatorCycleTable
					parentFilters={parentFilters}
					apiParams={{ "locationId": locationId }}
					onOpenForm={
						({ record }) => {
							const returnTo = encodeURIComponent(`/dashboardincubator?disableLoadPref=${params.disableLoadPref}&hideTypeFilter=${params.hideTypeFilter}&IsSterilized=${consts.SterilizeStatus.True}&BIResult=${record?.BIResult}`)
							navigate(`/incubatorcycledetailform?id=${record?.IncubatorCycleDetailId || 0}&attachmentCount=${record?.AttachmentCount || 0}&cycleId=${record?.CycleId || 0}&incubatorCycleId=${record?.IncubatorCycleId || 0}&isError=${record?.BIResult === consts.BIResult.Error}&isFromCycle=${false}&incubatorId=${record?.IncubatorId}&returnTo=${returnTo}`)
						}
					} />
			</Grid>
		</Grid>
	);
};

export default DashboardIncubatorList